<app-header
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<main>
    <app-policy-street-banner></app-policy-street-banner>
    <div
        class="tw-py-[50px] lg:tw-py-[34px] tw-px-[25px] md:tw-px-[30px] xl:tw-px-0"
    >
        <div
            class="tw-text-center md:tw-text-left tw-max-w-[1280px] tw-mx-auto"
        >
            <h3
                class="!tw-text-[#0F3172] !tw-text-[22px] md:!tw-text-[28px] !tw-font-bold"
            >
                {{
                    "INSURANCE_PAGE.POLICY_STREET.EMPLOYEE_PRODUCTS_OVERVIEW"
                        | translate
                }}
            </h3>
            <p class="!tw-text-[#1A202C] !tw-text-[14px]">
                {{ "INSURANCE_PAGE.POLICY_STREET.RESTRUCTURE" | translate }}
            </p>
        </div>
    </div>
    <app-policy-street-services></app-policy-street-services>
    <app-policy-street-form
        (onSubmit)="onSubmitPolicyStreetForm($event)"
    ></app-policy-street-form>
</main>
<app-footer (click)="closeMegaMenuCondition()"></app-footer>
